import mwrHttp from '@/utils/activityHttp'

// 双十一购物广场活动服务地址：开发环境走本地 8068 端口，测试/正式环境走网关服务名。
const isDev = process.env.VUE_APP_ENV === 'dev'
const actHost = isDev
  ? ''
  : String(process.env.VUE_APP_ACT_URL || '').replace(/\/$/, '')

let basePath = isDev
  ? '/minifire-nov-shopping/api/v1/sp'
  : `${actHost}/minifire-nov-shopping/api/v1/sp`

if (process.env.VUE_APP_ENV === 'prod') {
  basePath = `${String(process.env.VUE_APP_ACT_URL || 'https://wapi.miniworldgame.com').replace(/\/$/, '')}/minifire-nov-shopping/api/v1/sp`
}

export default {
  // 公共配置（未登录可读）
  getCommonConfig: (params = {}) => {
    return mwrHttp.post(`${basePath}/get-common-config`, params)
  },

  // 角色验证：服务端代查聚合 queryCpUserInfo 并记录登录
  queryCpUserInfo: (params = {}) => {
    return mwrHttp.post(`${basePath}/query-cp-user-info`, params)
  },

  // 用户活动态（购物券余额 / 累计消耗 / 商品与里程碑状态）
  getActivityInfo: (params = {}) => {
    return mwrHttp.post(`${basePath}/activity-info`, params)
  },

  // 兑换商品（count 批量数量，默认 1）
  purchase: (params = {}) => {
    return mwrHttp.post(`${basePath}/purchase`, params)
  },

  // 兑换记录
  getPurchaseRecord: (params = {}) => {
    return mwrHttp.post(`${basePath}/purchase-record`, params)
  },

  // 领取里程碑（rewardCode 为空一键领取全部可领档位）
  receiveMilestone: (params = {}) => {
    return mwrHttp.post(`${basePath}/milestone-receive`, params)
  },

  // 领取记录
  getMilestoneRecord: (params = {}) => {
    return mwrHttp.post(`${basePath}/milestone-record`, params)
  },
}
